import React, { useState } from 'react'
import { Link } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import car_data from "../Data/car_data.json"
import { AiFillCalendar } from "react-icons/ai"
import { HiCog } from "react-icons/hi"
import { FaSortAmountUp, FaCoins } from "react-icons/fa"

const Browse = () => {
    const [output, setOutput] = useState(car_data)

    // function to sort output based on browse-sort option picked
    const sortCategories = (category) => {
        let newArray = []
        // .filter is used because .sort does not create a new array, ans a new array needs to be created to re-render the component
        switch (category) {
            case "default":
                newArray = car_data.sort((a, b) => a.id - b.id)
                break;
            case "high-low":
                newArray = car_data.sort((a, b) => b.base_insurance - a.base_insurance)
                break;
            case "low-high":
                newArray = car_data.sort((a, b) => a.base_insurance - b.base_insurance)
                break;
            case "alphabetically":
                newArray = car_data.sort((a, b) => b.make > a.make ? -1 : 1)
                break;
            case "reg-year":
                newArray = car_data.sort((a, b) => b.year - a.year)
                break;
            case "rating":
                newArray = car_data.sort((a, b) => b.avg_rating - a.avg_rating)
                break;
            default:
        }
        newArray = newArray.filter((i) => i)
        return setOutput(newArray)
    }

  return (
    <>
        <section className='browse'>
            <div className="container browse-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Browse Cars</h1>
                <p className="section-caption">Choose from a selection of our rental cars below! We have a wide range of cars, ready to be rented at a click of a button.</p>
                <div className="browse-sort">
                    <label htmlFor="browse-sort" className='browse-sort-label'>
                        <span className="browse-sort-icon"><FaSortAmountUp/></span>
                        Sort By:
                    </label>
                    <select name="browse-sort" id="browse-sort" className='browse-sort-input' onChange={(event) => sortCategories(event.target.value)}>
                        <option value="default">Default</option>
                        <option value="high-low">Price (high - low)</option>
                        <option value="low-high">Price (low - high)</option>
                        <option value="alphabetically">Car Make (A-Z)</option>
                        <option value="reg-year">Registration Year</option>
                        <option value="rating">Rating</option>
                    </select>
                </div>
                <div className="browse-box"> 
                    {output.map((i) => {
                        return (
                            <div key={i.id} id={i.id} className="browse-card">
                                <div className="browse-img-container">
                                    <img src={i.img} alt="Car_img" />
                                </div>
                                <div className="browse-info-container">
                                    <h2 className="browse-card-title">{`${i.make} ${i.model}`}</h2>
                                    <div className="browse-span-container">
                                        <span className="browse-span">
                                            <span className="browse-card-icon"><AiFillCalendar/></span>
                                            <span className="browse-card-text">{i.year}</span>
                                        </span>
                                        <span className="browse-span">
                                            <span className="browse-card-icon"><HiCog/></span>
                                            <span className="browse-card-text">{i.transmission}</span>
                                        </span>
                                        <span className="browse-span">
                                            <span className="browse-card-icon"><FaCoins/></span>
                                            <span className="browse-card-text">£94 per day</span>
                                        </span>
                                    </div>
                                    <div className="browse-btn-container">
                                        <Link to="/checkout">
                                            <button className="btn btn-md btn-light rent-car">
                                                Rent Car
                                            </button>
                                        </Link>
                                        <Link to={`/browse/${i.id}`} target="_blank">
                                            <button className="btn btn-md browse-more-info">More Info</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    </>
  )
}

export default Browse